"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _LazyValueStore = require("../store/LazyValueStore");

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _ActionTypes = require("../actions/ActionTypes");

var _SettingsAPI = require("./SettingsAPI");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: function fetch() {
    return (0, _SettingsAPI.fetch)(_hubspot.default.get());
  },
  namespace: _ActionNamespaces.SETTINGS
}).defineName('SettingsStore').defineResponseTo([_ActionTypes.REVERT_SETTING, _ActionTypes.SET_SETTING], function (state, _ref) {
  var key = _ref.key,
      value = _ref.value;
  return state.setIn(['value', key], value);
}).defineResponseTo([_ActionTypes.DELETE_SETTING], function (state, _ref2) {
  var key = _ref2.key;
  return state.deleteIn(['value', key]);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;